exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.attention[data-v-dea918c2] {\n  color: #e3342f;\n  font-size: 1rem;\n}\n", ""]);

// exports
